module.exports = __webpack_public_path__ + "static/media/caiwubankuai.89c13807.png";